/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-07 10:45:05
 * @LastEditTime: 2022-02-06 17:46:22
 * @LastEditors: zhao - 🍉
 * @Description: 对账报表 - 单商户 对账数据
 * @FilePath: /zhzj-admin/src/page/AccountingRecordReport/components/MerchantReportInfoModal.jsx
 */
import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import ModalScrollContainer from '../../../components/ModalScrollContainer';
import MerchantReportInfoList from './MerchantReportInfoListView';
import StatisticsView from './MerchantReportInfoStatisticsView';
const MerchantReportInfo = (props) => {
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('');
    const [params, setParams] = useState({});
    const open = (params, title) => {
        setVisible(true)
        setParams(params)
        setTitle(title + ' （'+ params.date +'）')
    }
    const close = () => {
        setVisible(false)
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal visible={visible} width={900} title={title} onCancel={close} destroyOnClose footer={<Button onClick={close}>关闭</Button>}>
            <ModalScrollContainer>
                <StatisticsView params={params} />
                <MerchantReportInfoList params={params} />
            </ModalScrollContainer>
        </Modal>
    )
}

export default MerchantReportInfo


// WEBPACK FOOTER //
// ./src/page/AccountingRecordReport/components/MerchantReportInfoModal.jsx